module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.c1b04313.webp";